import BaseService from "./BaseService";

class TaxTypeService {
  static async GetTaxTypes(tennantId, token) {
    try {
      return await BaseService.get("taxtypes", token, { tennantId });
    } catch (error) {
      console.error("There was an error fetching the tax types!", error);
      throw error;
    }
  }
}

export default TaxTypeService;
